export default __webpack_public_path__ + "static/media/17-crafting-insights.d316b284.svg";